<style lang="scss" scoped>
@import "./custinforma.css";
</style>
<style>
  *, *::before, *::after{
      font-family: 'element-icons';

  }
  .confirmbtn{
      color: #FFFFFF !important;
      background-color: #09666e!important;
      border-color: #09666e!important;
  }
  .el-button--small:hover{
      background-color: #ffffff ;
      border-color: #dcdfe6 ;
      color: #000;
  }
</style>
<template>
  <div>
    <div v-if="taskFlag1" id="custinforma">
      <div class="topHeader">
        <a-form-model
          :model="params"
          style="width: 100%"
          labelAlign="right"
          layout="inline"
        >
          <a-row type="flex" justify="space-between">
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="帳戶狀態" class="formItem">
                <a-auto-complete
                  v-model="params.accountInfo"
                  :options="options"
                  style="width: 100%"
                  placeholder="請輸入證券號碼 / 客戶資訊"
                  @change="filterOption"
                >
                  <template slot="dataSource">
                      <a-select-option v-for='(item , ind) in options' :value="item.value" :key='ind'>
                      {{item.value}}
                    </a-select-option>
                  </template>
                </a-auto-complete>
              </a-form-model-item>
            </a-col>
            <!-- <a-col :xl="{ span: 6 }">
              <a-form-model-item label="帳號狀態" class="formItem">
                <a-input
                  v-model="params.accountInfo"
                  placeholder="請輸入證券號碼、名稱、電話、身份證號"
                />
              </a-form-model-item>
            </a-col> -->
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="登錄平台" class="formItem">
                <a-select
                  v-model="params.platform"
                  placeholder="請選擇登錄平台"
                  @change="platformClick($event)"
                >
                  <a-select-option
                    v-for="item in platformArr"
                    :key="item.label"
                    :value="item.value"
                  >
                    {{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
              <!-- <a-form-model-item label="國家地區" class="formItem">
                <a-select
                  v-model="params.area"
                  placeholder="請選擇國家地區"
                  @change="areaClick($event)"
                >
                  <a-select-option
                    v-for="item in countryArr"
                    :key="item"
                    :value="item"
                  >
                    {{ item }}</a-select-option
                  >
                </a-select>
              </a-form-model-item> -->
            </a-col>
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="提交時間" class="formItem">
                <!-- <a-date-picker
                  v-model="params.updateTime"
                  @change="fanhand"
                  placeholder="請選擇審更新時間"
                /> -->
                <a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
										v-model="params.updateTime" @change='fanhand'>
                </a-range-picker>
              </a-form-model-item>
            </a-col>
          </a-row>
          <br />
          <a-row type="flex" justify="space-between">
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="簽署文件" class="formItem">
                <a-select
                  v-model="params.filetype"
                  placeholder="請選擇簽署文件"
                  @change="filetypeClick($event)"
                >
                  <a-select-option
                    v-for="item in fileArr1"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="文件狀態" class="formItem">
                <a-select
                  v-model="params.fileStatus"
                  placeholder="請選擇文件狀態"
                  @change="fileClick($event)"
                >
                  <a-select-option
                    v-for="item in fileArr"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-col>

            <a-col :xl="{ span: 6 }" style="display: inline-flex;align-items: center;">
              <div
                class="btn_cla"
                style="background-color: #3bc7a1; margin-right:1rem"
                @click="searchEvent"
              >
                <img src="../../../image/icon_sousuo.png" class="btnIcon" />
                <span>搜索</span>
              </div>
              <div
                class="btn_cla"
                style="background-color: #ffa647; "
                @click="clearEvent"
              >
                <img src="../../../image/icon_chongzhi.png" class="btnIcon" />
                <span>重置</span>
              </div>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div class="bottomMain">
        <div class="tableBtnView">
          <button  class="bottomBtn" @click="addClick()">
            <img src="../../../image/emp1.png" class="btnIcon" />
            <span style="color: #ffa647">添加</span>
          </button>
          <!--  :action="$api.customerAdd" -->

          <a-upload name="file" :data='{token:$store.state.token,flag:"customerInformation"}' :headers='{token:$store.state.token}'
            class="avatar-uploader" :show-upload-list="false"
            :before-upload="beforeUpload" @change="handleChange" :action="$api.customerAdd" v-if="customerInfoImport">
            <button class="bottomBtn" v-loading.fullscreen.lock="fullscreenLoading">
              <img src="../../../image/endexs.png" class="btnIcon" />
              <span style="color: rgb(88, 133, 234);font-size: 0.8rem;">導入</span>
            </button>
          </a-upload>

          <button class="bottomBtn" @click="upClick()" >
            <a-icon
              type="file-pdf"
              style="
                width: 0.9rem;
                color: #3bc7a1;
                marginRight: 0.5rem;
                fontsize: 0.8rem;
              "
            />
            <span style="color: #3bc7a1">導出</span>
          </button>
          <button  class="bottomBtn" @click="handDelect" v-if="false">
            <img src="../../../image/stop.png" class="btnIcon" />
            <span style="color: #ed4849">註銷</span>
          </button>
           <button  class="bottomBtn" @click="approvalClick">
            <img src="../../../image/sp1.png" class="btnIcon" />
            <span style="color: #a06bf1">一鍵審批</span>
          </button>
          <!-- <button
            v-if="ipoAduitAdmin && params.missionflag > 0"
            class="bottomBtn"
            style="background-color: #a06bf1"
            @click="handipo"
          >
            <img src="../../../image/handall.png" class="btnIcon" />
            <span>批量審核</span>
          </button> -->
          <task :params="params" :pageNum="1" @child="fandfn" v-if="false"></task>
        </div>
        <div style="width: 100%; border: 1px solid #e8e8e8;">
          <el-table
            ref="multipleTable"
            :data="tableValue"
            tooltip-effect="dark"
            style="width: 100%;font-size: 0.85rem;color: #000000;"
            :header-cell-style="{ background: '#fafafa', color: '#000' }"
            @selection-change="handleSelectionChange"
            :row-class-name="tableRowClassName"
          >
            <template slot="empty">
              <el-empty :image-size="41" description= "No Data"></el-empty>
            </template>
            <el-table-column type="selection"  width="50" align="center">
            </el-table-column>
            <!-- <el-table-column width="30" align="right">
              <template slot-scope="scope">
                <img v-if="scope.row.status == 1" src="../../../image/stop.png" class="btnIcon" />
              </template>
            </el-table-column> -->
            <el-table-column
              prop="username"
              label="證券帳號"
              show-overflow-tooltip
              align="center"
            >
             <template slot-scope="scope">
                <span style="color: #0c8b97;cursor: pointer;" v-if="scope.row.msgeditflag == 1" @click="personalInfo(scope.row)">{{scope.row.username}}</span>
                <span v-else>{{scope.row.username}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="realname"
              label="客戶名稱"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="mobile"
              label="區號/號碼"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span>{{scope.row.mobile}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="area"
              label="國家/地區"
              show-overflow-tooltip
              align="center"
              v-if="false"
            >
              <template slot-scope="scope">
                <span>{{scope.row.area}}</span>
              </template>
            </el-table-column> -->
            <el-table-column
              width="280"
              prop="email"
              label="電郵地址"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span>{{scope.row.email}}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="150"
              prop="accountStatus"
              label="帳戶狀態"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span>{{scope.row.accountStatus}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="w8benfile_statusstr"
              label="W-8BEN"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span  v-if="scope.row.w8ben_missionid">
                  <span
                    style="color:#3bc7a1;cursor: pointer;"
                    @click="wBenSub(scope.row,1)"
                  >
                    {{ scope.row.w8benfile_statusstr }}
                  </span>
                  <img src="../../../image/audit.png"  style="position:absolute;margin-left:15px;margin-top: 2px;cursor: pointer;" @click="W8benClick(scope.row.w8ben_missionid)">
                </span>
                <span v-else>
                  <span
                    class="wBenCla"
                    :style="
                      scope.row.w8benfile_expiry_flag == 1 && scope.row.status != 1? 'color:#ed4849;cursor: pointer;' : ''
                    "
                    v-if="scope.row.w8benfile_expiry_flag == 1 && scope.row.status != 1"
                     @click="wBenSub(scope.row,2)"
                  >
                    {{ scope.row.w8benfile_statusstr }}
                   
                  </span>
                  <span
                    :style="
                      scope.row.w8benfile_expiry_flag == 1 && scope.row.status != 1? 'color:#ed4849' : ''
                    "
                    v-else
                  >
                    {{ scope.row.w8benfile_statusstr }}
                  </span>
                  <!-- <img v-if="scope.row.w8benfile_statusstr == '未簽署'|| scope.row.w8benfile_statusstr == '已過期'&& scope.row.status != 1" src="../../../image/signYes.png"  style="position:absolute;margin-left:15px;margin-top: 2px;cursor: pointer;" @click="notSigned('1',scope.row)"> -->
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="otcfile_statusstr"
              label="OTC"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.otc_missionid">
                  <span
                    style="color:#3bc7a1;cursor: pointer;"
                    @click="otcSub(scope.row,1)"
                  >
                    {{ scope.row.otcfile_statusstr }}
                  </span>
                  <!-- <img src="../../../image/audit.png"  style="position:absolute;margin-left:15px;margin-top: 2px;cursor: pointer;" @click="otcClick(scope.row.otc_missionid)"> -->
                </span>
                <span  v-else>
                  <span
                    :style="
                      scope.row.otcfile_expiry_flag == 1 && scope.row.status != 1? 'color:#ed4849;cursor: pointer;' : ''
                    "
                    class="otcCla"
                    v-if="scope.row.otcfile_expiry_flag == 1 && scope.row.status != 1"
                    @click="otcSub(scope.row,2)"
                  >
                    {{ scope.row.otcfile_statusstr }}
                  </span>
                  <span
                    :style="
                      scope.row.otcfile_expiry_flag == 1 && scope.row.status != 1? 'color:#ed4849' : ''
                    "
                    v-else
                  >
                    {{ scope.row.otcfile_statusstr }}
                  </span>
                </span>
                <!-- <img v-if="scope.row.otcfile_statusstr == '未簽署' || scope.row.otcfile_statusstr == '已過期' && scope.row.status != 1" src="../../../image/signYes.png" style="position:absolute;margin-left:15px;margin-top: 2px;cursor: pointer;" @click="notSigned('2',scope.row)"> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="hkidr_statusstr"
              label="HKIDR"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <!-- <span
                  :style="scope.row.hkidr_expiry_flag == 1 && scope.row.status != 1?  'color:#ed4849' : ''"
                >
                  {{ scope.row.hkidr_statusstr }}
                </span> -->
                  <!-- <img v-if="scope.row.hkidr_statusstr == '未簽署'&& scope.row.status != 1" src="../../../image/signYes.png" style="position:absolute;margin-left:15px;margin-top: 2px;cursor: pointer;" @click="notSigned('3',scope.row)"> -->

                <span>
                  <span
                    :style="
                      scope.row.hkidr_expiry_flag == 1 && scope.row.status != 1? 'color:#ed4849;cursor: pointer;' : ''
                    "
                    class="hkidrCla"
                    v-if="scope.row.hkidr_statusstr == '未簽署'&& scope.row.status != 1"
                    @click="hkidrSub(scope.row,2)"
                  >
                    {{ scope.row.hkidr_statusstr }}
                  </span>
                  <span
                    :style="
                      scope.row.hkidr_expiry_flag == 1 && scope.row.status != 1? 'color:#ed4849' : ''
                    "
                    v-else
                  >
                    {{ scope.row.hkidr_statusstr }}
                  </span>
                </span>
              </template>
            </el-table-column>
            <!-- 添加投資取向問卷列 and-->
            <el-table-column
              prop="w8benfile_statusstr"
              label="IOQ"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.questionnaire_sign_status == '已提交'" style="color:#3bc7a1;cursor: pointer;" >
                  <span @click="ioqSub(scope.row,1)">{{ scope.row.questionnaire_sign_status }}</span>
                  <img src="../../../image/audit.png"  style="position:absolute;margin-left:15px;margin-top: 2px;cursor: pointer;" @click="ioqClick(scope.row)">
                </span>
                <span v-else-if="scope.row.questionnaire_sign_status == '未簽署'" style="color:#ed4849;cursor: pointer;" class="ioqCla">
                  <span @click="ioqSub(scope.row,1)">{{ scope.row.questionnaire_sign_status }}</span>
                </span>
                <span v-else-if="scope.row.questionnaire_sign_status == '已過期'" style="color:#ed4849;cursor: pointer;" >
                  <span @click="ioqSub(scope.row,1)">{{ scope.row.questionnaire_sign_status }}</span>
                </span>
                <span v-else>
                  {{ scope.row.questionnaire_sign_status }}
                </span>
              </template>
            </el-table-column>
            <!-- 添加投資取向問卷列 end-->
            <!-- 添加風險取向問卷列 and-->
            <el-table-column
              prop="w8benfile_statusstr"
              label="RPQ"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.rpq_status == '已提交'" style="color:#3bc7a1;cursor: pointer;" >
                  <span @click="rpqSub(scope.row,1)">{{ scope.row.rpq_status }}</span>
                  <img src="../../../image/audit.png"  style="position:absolute;margin-left:15px;margin-top: 2px;cursor: pointer;" @click="ioqClick(scope.row)">
                </span> -->
                <span v-if="scope.row.rpq_status == '未簽署'" style="color:#ed4849;cursor: pointer;" class="ioqCla">
                  <span @click="rpqSub(scope.row,1)">{{ scope.row.rpq_status }}</span>
                </span>
                <span v-else-if="scope.row.rpq_status == '已過期'" style="color:#ed4849;cursor: pointer;" >
                  <span @click="rpqSub(scope.row,1)">{{ scope.row.rpq_status }}</span>
                </span>
                <span v-else>
                  {{ scope.row.rpq_status }}
                </span>
              </template>
            </el-table-column>
            <!-- 添加風險取向問卷列 end-->
            <!-- <el-table-column
              prop="updatetime"
              label="更新時間"
              show-overflow-tooltip
              align="center"
              v-if="false"
            >
              <template slot-scope="scope">
                {{scope.row.updatetime}}
              </template>
            </el-table-column> -->
            <el-table-column label="操作" show-overflow-tooltip align="center" >
              <template slot-scope="scope">
                <div style="display: flex;align-items:center;justify-content: center;">
                  <div type="text" @click="editClick(scope.row)"  size="small">
                    <img src="../../../image/icon_xiangqing.png" class="btnIcons" style="cursor: pointer;" />
                  </div>
                  
                  <div type="text"  @click='isopenss = true,addLists=scope.row'  size="small">
                    <img src="@/image/icon_mess_1.png" class="btnIcons" style="cursor: pointer;" />
                  </div>
                  <el-button type="text" @click="inquireClick(scope.row)" size="small"  v-if="false"> 
                    <img src="../../../image/icon_beizhu.png" class="btnIcons" />
                  </el-button>
                  <div type="text" @click="statusClick(scope.row)"  size="small" style="margin :0 0.5rem;" v-if="false">
                    <!-- <img src="../../../image/start.png" class="btnIcons1" /> -->
                    <img v-if="scope.row.status == 0" src="../../../image/pause.png" style="cursor: pointer;" class="btnIcons1" />
                    <img v-if="scope.row.status == 1" src="../../../image/stop.png" style="cursor: pointer;" class="btnIcons1" />
                    <img v-if="scope.row.status == 2" src="../../../image/start.png" style="cursor: pointer;" class="btnIcons1" />
                  </div>
                  <div type="text" @click="freezeClick(scope.row)"  size="small" v-if="false">
                    <img v-if="scope.row.is_freeze == 0" src="../../../image/thaw.png" style="cursor: pointer;" class="btnIcons1" />
                    <img v-if="scope.row.is_freeze == 1" src="../../../image/freeze.png" style="cursor: pointer;" class="btnIcons1" />
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paginationView">
          <div>
            第{{ firstPage }}到{{ secPage }}條，共{{ params.total }}條記錄，共{{stopnum}}條暫停
          </div>
          <div style="margin-left: auto">
            <a-pagination
              v-model="params.pageNum"
              @change="pageChange"
              :total="params.total"
              :pageSize="params.perPage"
            />
          </div>
          <div class="pageTzView">
            <input
              type="text"
              v-model="tzPageNum"
              @onkeyup="valueFn"
              @onafterpaste="valueFn"
            />
            <span @click="tzEvent">跳轉</span>
          </div>
        </div>
      </div>
      <div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
        <div class="pdfviewIn">
          <div class="pdfTitle">
            <img @click.stop="printEvent()" src="../../../image/icon_dayin.png">
          </div>
          <iframe id="iframePdf1" :src="allurl" style="width: 100%; height: 100%" frameborder="0"></iframe>
          <iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
        </div>
      </div>
      <div :class="['pdfview',pdfShow1 ? 'pdfShow' : '']" @click="pdfShowUNEvent1()">
        <div class="pdfviewIn pdfviewIn1" >
          <div class="pdfTitle">
            <img @click.stop="printEvent1()" src="../../../image/icon_dayin.png">
          </div>
          <iframe id="iframePdf1" :src="allurl1" style="width: 100%; height: 100%" frameborder="0"></iframe>
          <iframe id="toPrintIframe1" style="display:none;" :src="pdfBolUrl1" frameborder="0"></iframe>
        </div>
      </div>
      <handItem v-if="isopen" @child="handclose" :items='isdate' :stateFlag="stateFlag"></handItem>
      <handItems v-if="isopens"  @child="handcloses" :items='username' ></handItems>
      <approval v-if="approvalFlag" @child="approvalFlagClick" :items='isdate' :wBen="wBen" :file_type="file_type" ></approval>
      <ioqdiv v-if="ioqFlag" @child="ioqFlagClick" :items='isdate' :wBen="wBen" :file_type="file_type"></ioqdiv>
      <rpqdiv v-if="rpqFlag" @child="rpqFlagClick" :items='isdate' :wBen="wBen" :file_type="file_type"></rpqdiv>
      <fundExamine v-if="isopenss" @child='hand_shenhe_close' :param = addLists></fundExamine>
      <personalInformation v-if="personalInfoFlag " @child="personalInfoClick" :items='isdate' :wBen="wBen" :file_type="file_type" ></personalInformation>
      <customerInformation v-if="customerInfoFlag" @child="customerInfoClick" :items='isdate' :wBen="wBen" :file_type="file_type" :dataList ='dataList'></customerInformation>
    </div>
    <div v-if="taskFlag2" id="custinforma">
      <div class="topHeader">
        <a-form-model
          :model="params"
          style="width: 100%"
          labelAlign="right"
          layout="inline"
        >
          <a-row type="flex" justify="space-between">
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="帳號信息" class="formItem">
                <a-input
                  v-model="params.accountInfo"
                  placeholder="請輸入證券號碼、名稱、電話、身份證號"
                />
              </a-form-model-item>
            </a-col>
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="國家地區" class="formItem">
                <a-select
                  v-model="params.area"
                  placeholder="請選擇國家地區"
                  @change="areaClick($event)"
                >
                  <a-select-option
                    v-for="item in countryArr"
                    :key="item"
                    :value="item"
                  >
                    {{ item }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="提交時間" class="formItem">
                <a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
										v-model="params.updateTime" @change='fanhand'>
                </a-range-picker>
              </a-form-model-item>
            </a-col>
          </a-row>
          <br />
          <a-row type="flex" justify="space-between">
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="簽署文件" class="formItem">
                <a-select
                  v-model="params.filetype"
                  placeholder="請選擇簽署文件"
                  @change="filetypeClick($event)"
                >
                  <a-select-option
                    v-for="item in fileArr1"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xl="{ span: 6 }">
              <a-form-model-item label="文件狀態" class="formItem">
                <a-select
                  v-model="params.fileStatus"
                  placeholder="請選擇文件狀態"
                  @change="fileClick($event)"
                >
                  <a-select-option
                    v-for="item in fileArr"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-col>

            <a-col :xl="{ span: 6 }">
              <a-button
                class="topBtn"
                style="background-color: #3bc7a1; margin-right: 2rem"
                @click="searchEvent"
              >
                <img src="../../../image/icon_sousuo.png" class="btnIcon" />
                <span>搜索</span>
              </a-button>
              <a-button
                class="topBtn"
                style="background-color: #ffa647; margin-left: auto"
                @click="clearEvent"
              >
                <img src="../../../image/icon_chongzhi.png" class="btnIcon" />
                <span>重置</span>
              </a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div class="bottomMain">
        <div class="tableBtnView">
          <button  class="bottomBtn" @click="addClick()">
            <img src="../../../image/emp1.png" class="btnIcon" />
            <span style="color: #ffa647">添加</span>
          </button>
          <button  class="bottomBtn" >
            <img src="../../../image/endexs.png" class="btnIcon" />
            <span style="color: rgb(88, 133, 234)">導入</span>
          </button>
          <button class="bottomBtn" @click="handopen">
            <a-icon
              type="file-pdf"
              style="
                width: 0.9rem;
                color: #3bc7a1;
                marginright: 0.3rem;
                fontsize: 0.8rem;
              "
            />
            <span style="color: #3bc7a1">導出</span>
          </button>
          <!-- <a-button
            v-if="ipoAduitAdmin && params.missionflag > 0"
            class="bottomBtn"
            style="background-color: #a06bf1"
            @click="handipo"
          >
            <img src="../../../image/handall.png" class="btnIcon" />
            <span>批量審核</span>
          </a-button> -->
          <task :params="params" :pageNum="2" @child="fandfn"></task>
        </div>
        <div style="width: 100%; border: 1px solid #e8e8e8;">
          <el-table
            ref="multipleTable"
            :data="tableValue"
            tooltip-effect="dark"
            style="width: 100%;font-size: 0.85rem;color: #000000;"
            :header-cell-style="{ background: '#fafafa', color: '#000' }"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <el-empty :image-size="41" description= "No Data"></el-empty>
            </template>
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column
              prop="username"
              label="證券帳號"
              show-overflow-tooltip
              align="center"
            >
            <template slot-scope="scope">
              <span>{{scope.row.username}}</span>
            </template>
            </el-table-column>
            <el-table-column
              prop="cn_name"
              label="中文名稱"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="mobile"
              label="區號/號碼"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span>{{scope.row.mobile}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="area"
              label="國家/地區"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span>{{scope.row.area}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="file_type"
              label="簽署文件"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.file_type==1" style="color:rgb(12, 139, 151);text-decoration:underline;cursor: pointer;" @click="W8benClick(scope.row.w8ben_missionid)"> W-8BEN</span>
                <span v-if="scope.row.file_type==2">OTC</span>
                <span v-if="scope.row.file_type==3">HKIDR</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="file_status"
              label="文件狀態"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  :style="
                    scope.row.file_status == '簽署失敗' ? 'color:#ed4849' : ''
                  "
                >
                  {{ scope.row.file_status }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createtime"
              label="提交時間"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{scope.row.createtime}}
              </template>
            </el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="auditClick(scope.row)" size="small">
                  <img src="../../../image/approval.png" class="btnIcons" style="width:1.3rem" />
                </el-button>
                <el-button type="text" @click="auditClick(scope.row)" size="small">
                  <img src="@/image/icon_mess.png" class="btnIcons" style="width:1.3rem" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paginationView">
          <div>
            第{{ firstPage }}到{{ secPage }}條，共{{ params.total }}條記錄
          </div>
          <div style="margin-left: auto">
            <a-pagination
              v-model="params.pageNum"
              @change="pageChange"
              :total="params.total"
              :pageSize="params.perPage"
            />
          </div>
          <div class="pageTzView">
            <input
              type="text"
              v-model="tzPageNum"
              @onkeyup="valueFn"
              @onafterpaste="valueFn"
            />
            <span @click="tzEvent">跳轉</span>
          </div>
        </div>
      </div>
      <!-- 222222222222 -->
      <div :class="['pdfview',pdfShow1 ? 'pdfShow' : '']" @click="pdfShowUNEvent1()">
        <div class="pdfviewIn pdfviewIn1" >
          <div class="pdfTitle">
            <img @click.stop="printEvent()" src="../../../image/icon_dayin.png">
          </div>
          <iframe id="iframePdf1" :src="allurl1" style="width: 100%; height: 100%" frameborder="0"></iframe>
          <iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl1" frameborder="0"></iframe>
        </div>
      </div>
      <audit v-if="auditFlag" @child="auditFlagClick" :items='isdate' :stateFlag="stateFlag"></audit>
      <handItem v-if="isopen" @child="handclose" :items='isdate' :stateFlag="stateFlag"></handItem>
    </div>
    <!-- 搜索无结果弹窗 -->
    <div>
      <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
          <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
              <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                  提 示
              </div>
          </div>
          <div solt='title' style="position: relative;"></div>
          <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
              <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
          </div>
          <div style="text-align: right">
              <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
              <button class='btn-main' @click='ishandout = false'>確 認</button>
          </div>
      </a-modal>
    </div>
    <exportData  v-if="upFlag" @child="upclose" ></exportData>
  </div>
</template>

<script>
import fundExamine from './components/fundExamine'
import exportData from "./components/exportData";
import task from './components/task.vue'
import handItem from "./components/handItem";
import handItems from "./components/handItems";
import approval from "./components/approval";
import ioqdiv from "./components/ioqdiv";
import rpqdiv from "./components/rpqdiv";
import personalInformation from "./components/personalInformation";
import customerInformation from "./components/customerInformation";
import audit from "./components/audit";
import App from "@/assets/app.js";
import https from '@/plugins/http.js';
export default {
  components: {
    task,
    handItem,
    handItems,
    approval,
    ioqdiv,
    rpqdiv,
    audit,
    personalInformation,
    customerInformation,
    fundExamine,
    exportData
  },
  computed: {
    firstPage: function () {
      console.log(this.params);
      let _this = this;
      let a = _this.params.pageNum - 1;
      let b = 1;
      return _this.params.total > 0 ? Number(a) + Number(b) : 0;
    },
    secPage: function () {
      let _this = this;
      let a = _this.params.pageNum * 10;
      let b = a > _this.params.total ? _this.params.total : a;
      return b;
    },
  },
  data() {
    return {
      addLists:'',
      isopenss: false,
      upFlag:false,
      fullscreenLoading: false,
      ishandout: false,
      dataList:{},
      value:'',
      username:'',
      taskFlag1: true,
      taskFlag2: false,
      seleDisFlag: false,
      params: {
        loginAccount: "", //登录账号
        accountInfo: "", //账号信息
        area: "", //国家地区
        platform: "", //登錄平台
        fileStatus: "", //文件状态
        filetype: "", //簽署状态
        updateTime: [], //更新时间
        updatetime_begin: '', //更新时间
        updatetime_end: '', //更新时间

        // 任務數
        missionnum: 1,
        pageNum: 1, //當前頁數
        total: 1, //总条数
        stockcode: "",
        perPage: 10, //每頁條目數
        username: "",
        status: "",
        handletime: "",
        createtime: "", //認購起始日期
        missionflag: false,
        tradetype: "",

      },
      //: "編輯管理員": "ipoAdmin"有新增 编辑权限     审批管理员 ipoAduitAdmin 审批权限
      ipoAdmin: this.$store.state.rolesdata.indexOf("ipoAdmin") >= 0,
      ipoAduitAdmin: this.$store.state.rolesdata.indexOf("ipoAduitAdmin") >= 0,
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
      customerInfoImport: this.$store.state.rolesdata.indexOf("customerInfoImport") >= 0,
      token: this.$store.state.token,
      countryArr: ['全部'], //国家地区内容
      platformArr: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "iPhone",
        },
        {
          value: "2",
          label: "iPad",
        },
        {
          value: "3",
          label: "Android",
        },
        {
          value: "4",
          label: "Website",
        },
        {
          value: "5",
          label: "Email",
        },
        {
          value: "6",
          label: "Telephone",
        },
        {
          value: "7",
          label: "Post",
        },
        {
          value: "8",
          label: "System",
        },
      ], //国家地区内容
      //文件状态内容 
      fileArr: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "未簽署",
        },
        {
          value: "2",
          label: "簽署成功",
        },
        {
          value: "3",
          label: "即將過期",
        },
        {
          value: "4",
          label: "已過期",
        },
        {
          value: "5",
          label: "已提交",
        },
      ], //文件状态内容
      fileArr1: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "W-8BEN",
        },
        {
          value: "2",
          label: "OTC",
        },
        {
          value: "3",
          label: "HKIDR",
        },
        {
          value: "4",
          label: "IOQ",
        },
        {
          value: "5",
          label: "RPQ",
        },
      ], //文件状态内容
      options:[
        {value:'全部'}, 
        {value:'正常'}, 
        {value:'暫停'},
        {value:'不動'},
        {value:'註銷'}
      ],
      filestatus: "",
      filetype: "",
      countryRegion: "",
      tableValue: [],
      multipleSelection: [],
      tzPageNum: "",
      isopen: false,
      isopens: false,
      auditFlag: false,
      isdate:{},
      stateFlag:1,
      pdfShow: false,
      pdfShow1: false,
      pdfBolUrl: '',
      allurl: '',
      pdfBolUrl1: '',
      allurl1: '',
      missionflag: '',
      stopnum: '',
      normalnum: '',
      approvalFlag: false,
      ioqFlag: false,
      rpqFlag: false,
      personalInfoFlag: false,
      customerInfoFlag: false,
      wBen:'',
      file_type:'',
      way:''
    };
  },
  mounted() {
    console.log(this.$store.state.token,'token查看',this.userfileAuditAdmin);
    this.tableData();
    // this.areaData();
  },
  methods: {
    hand_shenhe_close(){
      this.isopenss = false;
      this.tableData()
    },
    handleCancel(ev){
      this.ishandout = false
    },
    filterOption(input, option){
      this.tableData();
      console.log(input, option);
      // this.
      // return option.value.toUpperCase().indexOf(input.toUpperCase()) >= 0;
    },
    selectableFunc(){
      return false;
    },
    tableRowClassName({row, rowIndex}) {
      // console.log(row,'logggggggg');
      if (row.status == 1) {
        return 'table_stop';
      }
      if (row.status == 2) {
        return 'table_stop1';
      }
      if (row.hkidr_statusstr == '簽署成功' && row.otcfile_statusstr == '簽署成功' && row.w8benfile_statusstr == '簽署成功'&& row.questionnaire_sign_status == '簽署成功'&& row.msgeditflag != 1) {
        return 'table_stop1';
      }
      if (row.is_freeze == 1) {
        return 'table_stop1';
      }
    },
    //otc已提交
    otcSub(val,state){
      if (this.userfileAuditAdmin || state == 1) {
        this.approvalFlag = true;
        this.isdate = val;
        this.wBen = state;
        this.file_type = '2';
        console.log("otc已提交按鈕");
      }else{
        App.oTool.warningT('暫無權限');
      }

    },
    //w-8Ben已提交
    wBenSub(val,state){
      if (this.userfileAuditAdmin || state == 1) {
        this.approvalFlag = true;
        this.isdate = val;
        this.wBen = state;
        this.file_type = '1';
        console.log('w-8Ben已提交',state);
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    //ioq已提交
    ioqSub(val,state){
      if (this.userfileAuditAdmin || state == 1) {
        this.ioqFlag = true;
        this.isdate = val;
        this.wBen = state;
        this.file_type = '4';
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    //RPQ已提交
    rpqSub(val,state){
      if (this.userfileAuditAdmin || state == 1) {
        this.rpqFlag = true;
        this.isdate = val;
        this.wBen = state;
        this.file_type = '4';
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    //hkidr已提交
    hkidrSub(val,state){
      if (this.userfileAuditAdmin) {
        this.approvalFlag = true;
        this.isdate = val;
        this.wBen = state;
        this.file_type = '3';
        console.log('w-8Ben已提交',state);
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    approvalFlagClick(){
      this.approvalFlag = false;
      this.tableData();
    },
    ioqFlagClick(){
      this.ioqFlag = false;
      this.tableData();
    },
    rpqFlagClick(){
      this.rpqFlag = false;
      this.tableData();
    },
    personalInfoClick(){
      this.personalInfoFlag = false;
      this.tableData();
    },
    customerInfoClick(){
      this.customerInfoFlag = false;
      this.tableData();
    },
    // 列表签署图标按钮
    notSigned(value,row){
      if (this.userfileAuditAdmin) {
        console.log("签署图标----",value,row.username);
        this.$ajax({
          method: "post",
          // url: "http://202.130.113.149:3785/admin/newFileInputHandle",
          url: this.$api.newFileInputHandle,
          data: {
            username:row.username,
            filetype:value  //1 w-8ben  2 otc 3 hkidr
          },
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            this.tableData();
            App.oTool.successT('操作成功');
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    //國家數據
    areaData(){
      this.$ajax({
        method: "post",
        // url: "http://202.130.113.149:3785/admin/getParamList",
        url: this.$api.getParamList,
        data: {
         type:"userfilearea",
         searchstr:'',
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.countryArr = this.countryArr.concat(res.data.result) 
          this.params.area = '全部'
        } else {
         
        }
      });
    },
    //w-8ben PDF
    W8benClick(val){
      // if (this.userfileAuditAdmin) {
        console.log("8bena按钮",val);
        let str = this.$api.pdfs; //getUnsk
        // let url = 'http://202.130.113.149:3785/admin/getUserFilepdf';
        // url += '?m=' + Date.parse(new Date())
        let url = this.$api.getUserFilepdf;
        url += '?token=' + this.$store.state.token + '&m=' + Date.parse(new Date()) + '&missionid=' + val
        this.allurl1 = str + url
        let _this = this;
        _this.pdfUrl = url
        https.fetchGetPdf(_this.pdfUrl).then((data) => {
          let blob = new Blob([data], {
            type: 'application/pdf'
          });
          _this.blob = blob;
          let b = window.URL.createObjectURL(blob);
          _this.pdfBolUrl1 = b;
        }).catch(err => {
          console.log(err);
        });
          //
        setTimeout(() => {
          this.pdfShow1 = true;
        }, 500);
      // }else{
      //   App.oTool.warningT('暫無權限');
      // }
    },
    ioqClick(val){
      // if (this.userfileAuditAdmin) {
        console.log("8bena按钮",val);
        let str = this.$api.pdfs; //getUnsk
        // let url = 'http://202.130.113.149:3785/admin/getUserFilepdf';
        // url += '?m=' + Date.parse(new Date())
        let url = this.$api.getInvestOrientationQuestionnairePDF;
        url += '?token=' + this.$store.state.token + '&m=' + Date.parse(new Date()) + '&username=' + val.username
        this.allurl1 = str + url
        let _this = this;
        _this.pdfUrl = url
        https.fetchGetPdf(_this.pdfUrl).then((data) => {
          let blob = new Blob([data], {
            type: 'application/pdf'
          });
          _this.blob = blob;
          let b = window.URL.createObjectURL(blob);
          _this.pdfBolUrl1 = b;
        }).catch(err => {
          console.log(err);
        });
          //
        setTimeout(() => {
          this.pdfShow1 = true;
        }, 500);
      // }else{
      //   App.oTool.warningT('暫無權限');
      // }
    },
    //审核按钮
    auditClick( val){
      this.auditFlag = true
      this.isdate = val;
      console.log("审核按钮");
    },
    //国家地区下拉框
    areaClick(val) {
      if(val == '全部'){
        this.countryRegion = '';
      }else{
        this.countryRegion = val;
      }
      console.log("国家地区下拉框!",val);
      this.tableData();
    },
    //登錄平台下拉框
    platformClick(val) {
      if(val == '全部'){
        this.way = '';
      }else{
        this.way = val;
      }
      console.log("国家地区下拉框!",val);
      this.tableData();
    },
    //文件状态下拉框
    fileClick(val) {
      this.filestatus = val;
      console.log("文件状态下拉框!", val);
      this.tableData();
    },
    //簽署文件下拉框
    filetypeClick(val) {
      if (this.taskFlag2) {
        if (this.params.filetype == '1') {
          this.fileArr = [
            {
              value: "",
              label: "全部",
            },
            {
              value: "2",
              label: "重新簽署",
            },
            {
              value: "3",
              label: "簽署失敗",
            }
          ];
        }else{
           this.fileArr = [
            {
              value: "",
              label: "全部",
            },
            {
              value: "2",
              label: "重新簽署",
            },
            {
              value: "1",
              label: "提交簽署",
            }
          ];
        }
      }
      this.filetype = val;
      console.log("簽署文件下拉框!", val);
      this.tableData();
    },
    //选择时间
    fanhand() {
      console.log("选择时间!");
      this.params.updatetime_begin = this.params.updateTime[0] ? App.oDate.secsTime3(this.params.updateTime[0]._d) : '',
					//認購截止日期
      this.params.updatetime_end = this.params.updateTime[1] ? App.oDate.secsTime3(this.params.updateTime[1]._d) : ''
    },
    // 搜索按钮
    searchEvent() {
      this.tableData();
      console.log("搜索按钮!", this.params.updateTime);
    },
    // 重置按钮
    clearEvent() {
      this.params = {
        loginAccount: "", //登录账号
        accountInfo: "", //账号信息
        countryRegion: "", //国家地区
        platform: "", //登錄平台
        fileStatus: "", //文件状态
        filetype: "", //簽署文件
        updateTime: "", //更新时间
        pageNum: 1, //當前頁數
        total: 10,
        perPage: 10, //每頁條目數
        missionnum:''
      };
      this.searchstr = ''
      this.countryRegion = ''
      this.filestatus = ''
      this.filetype = ''
      this.way = ''
      this.tableData();
    },
    // 列表数据
    tableData() {
      console.log(this.filestatus);
      this.$ajax({
        method: "post",
        // url: "http://202.130.113.149:3785/admin/getQmisUserMsgList",
        url: this.$api.getQmisUserMsgList,
        data: {
          pageNum: this.params.pageNum,
          perPage: this.params.perPage,
          searchstr: this.params.accountInfo, //账号信息
          area:this.countryRegion,//國家地區
          way:this.way,//國家地區
          filestatus: this.filestatus, //文件状态
          filetype: this.params.filetype, //簽署文件
          updatetime_begin: this.params.updatetime_begin, //起止时间
          updatetime_end: this.params.updatetime_end, //終止时间
          missionflag : this.missionflag
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.tableValue= res.data.result;
          this.params.pageNum = res.data.pageNum;
          this.params.total = res.data.total;
          this.params.perPage = res.data.perPage;
          this.params.missionnum = res.data.missionnum;
          this.normalnum = res.data.normalnum;
          this.stopnum = res.data.stopnum;
          if (this.params.accountInfo || this.params.platform || this.params.updatetime_begin || this.params.filetype || this.params.fileStatus) {
            if (this.tableValue.length<=0) {
              this.ishandout = true
            }
          }
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    // 客戶信息查詢
    echoData(username){
      this.$ajax({
        method: "post",
        // url: "http://202.130.113.149:3785/admin/getQmisUserMsgWithUsername",
        url: this.$api.getQmisUserMsgWithUsername,
        data: {
          username: username,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          var that = this
          that.isdate = res.data;
          // that.isopen = true;
          this.customerInfoFlag = true
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    // 添加按鈕
    addClick(){
      if (this.userfileAuditAdmin) {
        this.stateFlag = 1;
        this.isopen = true;
        this.isdate = {};
        console.log("添加按钮");
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    //客戶信息按鈕
    editClick(val){
      this.dataList = val;
      // this.stateFlag = 3;
      this.echoData(val.username);
      // this.isdate = val;
      // this.customerInfoFlag = true
    },
    //导出按钮
    handopen(pxfs) {
      if (this.userfileAuditAdmin) {
        console.log("导出按钮");
				let str = this.$api.pdfs; //getUnsk
				// let url = 'http://202.130.113.149:3785/admin/getQmisUserFileInfoPdf';
        let sort =  pxfs == undefined ? '' : pxfs
				let url = this.$api.getQmisUserFileInfoPdf;
				// url += '?m=' + Date.parse(new Date())
        let updatetime_begin = this.params.updatetime_begin == 'undefined' ? '' : this.params.updatetime_begin
        let updatetime_end = this.params.updatetime_end == 'undefined' ? '' : this.params.updatetime_end
				url += '?token=' + this.$store.state.token + '&m=' + Date.parse(new Date()) + '&searchstr=' + this.params.accountInfo 
        + '&way=' + this.way
        + '&filestatus=' + this.filestatus
        + '&filetype=' + this.filetype
        + '&updatetime_begin=' + updatetime_begin
        + '&updatetime_end=' + updatetime_end
        + '&missionflag=' + this.params.missionflag
        + '&sort=' + sort

				this.allurl = str + url
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});
			    //
				setTimeout(() => {
					this.pdfShow = true;
				}, 500);
      }else{
      App.oTool.warningT('暫無權限');
      }
    },
    //导入按钮方法
    beforeUpload(file) {

      return new Promise((resolve, reject) => {
        this.$confirm("只能上傳列表中沒有的新數據", "提示", {
						confirmButtonText: "確認",
						cancelButtonText: "取消",
						confirmButtonClass: "confirmbtn",//自定义class
						type: "warning"
					}).then(() => {
            var fileFormat = file.name
              .substring(file.name.lastIndexOf("."))
              .toLowerCase();
            const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
            if (!isJpgOrPng) {
              this.$message.error('只能上傳xls或xlsx文件!');
            }else{
              resolve(file);
            }
            return isJpgOrPng;
          }).catch(() => {

          })
      });

    
    },
    //导入按钮
    handleChange(info) {
      if (this.customerInfoImport) {
        this.fullscreenLoading = true;
        if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.fullscreenLoading = false;
						this.loading = true;
						this.$message.success('導入成功');
						this.tableData();
					} else {
						this.loading = false;
            this.fullscreenLoading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    //批量审核
    fandfn(ev) {
      console.log("批量审核",ev);
      this.taskFlag1 = !this.taskFlag1;
      this.taskFlag2 = !this.taskFlag2;
      if (this.taskFlag2) {
        this.fileArr1 = [
          {
            value: "",
            label: "全部",
          },
          {
            value: "1",
            label: "W-8BEN",
          },
          {
            value: "2",
            label: "OTC",
          },
        ]; //文件状态内容
        this.fileArr = [
          {
            value: "",
            label: "全部",
          },
          {
            value: "2",
            label: "重新簽署",
          },
          {
            value: "1",
            label: "提交簽署",
          },
        ]; //文件状态内容
      }else{
        this.fileArr1 = [
          {
            value: "",
            label: "全部",
          },
          {
            value: "1",
            label: "W-8BEN",
          },
          {
            value: "2",
            label: "OTC",
          },
          {
            value: "3",
            label: "HKIDR",
          },
        ]; //文件状态内容
         this.fileArr = [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "未簽署",
        },
        {
          value: "2",
          label: "簽署成功",
        },
        {
          value: "3",
          label: "即將過期",
        },
        {
          value: "4",
          label: "已過期",
        },
      ];//文件状态内容
      }
      if (ev == 1) {
        this.missionflag = '1'
      }else{
        this.missionflag = ''
      }
      this.clearEvent()

    },
    //签署文件详情
    inquireClick(val){
      if (this.userfileAuditAdmin) {
        this.isopens = true;
        this.username = val.username;
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    freezeClick(val){
      let is_freeze = ''
      if (val.is_freeze == 0) {
        is_freeze = 1
      }else{
        is_freeze = 0
      }

      this.$ajax({
          method: "post",
          // url: "http://202.130.113.149:3785/admin/stopUserFileUse",
          url: this.$api.freezeCustomerAccount,
          data: {
            username: val.username,
            is_freeze: is_freeze,
          },
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            App.oTool.successT(res.data.qmismsg);
            this.tableData();
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });

    },
    //列表状态切换
    statusClick(val){
      if (this.userfileAuditAdmin) {
        console.log(val);
        if (val.status == 0 || val.status == 2) {
          let status
          if (val.status == 0) {
            status = 2
          }
          if (val.status == 2) {
            status = 0
          }
          this.changeQmisUserStatus(val.username,status)
        }
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    changeQmisUserStatus(username,status){
        this.$ajax({
          method: "post",
          // url: "http://202.130.113.149:3785/admin/stopUserFileUse",
          url: this.$api.changeQmisUserStatus,
          data: {
            username: username,
            status: status,
          },
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            App.oTool.successT(res.data.qmismsg);
            this.tableData();
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });
    },
    //个人信息
    personalInfo(val){
      this.isdate = val;
      this.personalInfoFlag = true;
      console.log("个人信息");
    },
    //停止按钮
    handDelect() {
      if (this.userfileAuditAdmin) {
        console.log("停止按钮");
        let usernameList = [];
        if (this.multipleSelection) {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            usernameList.push(this.multipleSelection[i].username)
          }
          this.$refs.multipleTable.clearSelection();
          console.log(usernameList,'username');
        } else {
          this.$refs.multipleTable.clearSelection();
        }
        if (usernameList.length>0) {
          this.$confirm("是否註銷此數據，註銷後數據不可恢復", "是否註銷？", {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                confirmButtonClass: "confirmbtn",//自定义class
                type: "warning"
            }).then(() => {
                // confirmButton回调
                this.$ajax({
                  method: "post",
                  // url: "http://202.130.113.149:3785/admin/stopUserFileUse",
                  url: this.$api.stopUserFileUse,
                  data: {
                    usernameList: usernameList,
                  },
                }).then((res) => {
                  if (res.data.qmiscode == 1000) {
                    App.oTool.successT(res.data.qmismsg);
                    this.tableData();
                  } else {
                    App.oTool.warningT(res.data.qmismsg);
                  }
                });
                next()
            }).catch(() => {
            })

        }
      }else{
        App.oTool.warningT('暫無權限');
      }

      
    },
    //一鍵審批
    approvalClick(){
      if (this.userfileAuditAdmin) {
        // console.log(this.filetype);
        // console.log(this.filestatus);
        if (this.filetype == 2 && this.filestatus == 3) {
          console.log("多選一鍵審批");
          let usernameList = [];
          if (this.multipleSelection) {
            for (let i = 0; i < this.multipleSelection.length; i++) {
              usernameList.push(this.multipleSelection[i].username)
            }
            this.$refs.multipleTable.clearSelection();
            console.log(usernameList,'username');
          } else {
            this.$refs.multipleTable.clearSelection();
          }
          console.log(usernameList);
          if (usernameList.length>0) {
            console.log("調接口");
            this.$ajax({
              method: "post",
              url: this.$api.OtcFileAuditByList,
              data: {
               userslist:usernameList
              },
            }).then((res) => {
              if (res.data.qmiscode == 1000) {
                App.oTool.successT('操作成功');
                this.tableData();
              } else {
                App.oTool.warningT(res.data.qmismsg);
              }
            });
          }else{
            console.log("沒東西");
          }
  
        }else{
          App.oTool.warningT('請在搜索欄選擇 簽署文件(OTC) 和 文件狀態(即將過期)');
        }
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection,'选择框');
    },
    pageChange(page, pageSize) {
      this.params.pageNum = page;
      this.tableData();
    },
    valueFn() {
      this.tzPageNum = this.tzPageNum.replace(/\D/g, "");
    },
    tzEvent() {
      let _this = this;
      let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
      if (_this.tzPageNum <= maxPageNum) {
        _this.params.pageNum = Number(_this.tzPageNum);
        _this.tableData();
      } else {
        App.oTool.warningT("請輸入有效的頁碼");
      }
    },
    handclose(val) {
      this.isopen = false;
      this.tableData();
      console.log(val);
    },
    auditFlagClick(val) {
      this.auditFlag=false;
      console.log(val);
      this.tableData();
    },
    handcloses(val) {
      this.isopens = false;
      console.log(val);
    },
    pdfShowUNEvent() {
      this.pdfShow = false;
    },
    pdfShowUNEvent1() {
      this.pdfShow1 = false;
    },
    printEvent() {
      let _this = this; //toPrintIframe
      const printIframe = document.getElementById("toPrintIframe");
      let frameWindow = printIframe.contentWindow;
      console.log(frameWindow)
      frameWindow.print();
      setTimeout(() => {
        window.URL.revokeObjectURL(_this.blob);
      }, 500)
    },
    printEvent1() {
      let _this = this; //toPrintIframe
      const printIframe = document.getElementById("toPrintIframe1");
      let frameWindow = printIframe.contentWindow;
      console.log(frameWindow)
      frameWindow.print();
      setTimeout(() => {
        window.URL.revokeObjectURL(_this.blob);
      }, 500)
    },
    queryData(val){
      let updatetime_begin = this.params.updatetime_begin == 'undefined' ? '' : this.params.updatetime_begin
      let updatetime_end = this.params.updatetime_end == 'undefined' ? '' : this.params.updatetime_end
      let url = ''
      let _this = this;
      let sort =  val == undefined ? "" : val
      url = _this.$api.exportCustomerExcel;
      url += '?token=' + _this.$store.state.token
      url += '&m=' + Date.parse(new Date())
      url += '&searchstr=' + this.params.accountInfo 
      url += '&way=' + this.way
      url += '&filestatus=' + this.filestatus
      url += '&filetype=' + this.filetype
      url += '&updatetime_begin=' + updatetime_begin
      url += '&updatetime_end=' + updatetime_end
      url += '&missionflag=' + this.params.missionflag
      url += '&headRows=2'
      url += '&sort=' + sort
      
      console.log(url);
      window.location.href = url;
    },
    upClick(){
      if (this.userfileAuditAdmin) {
        this.upFlag = true
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    upclose(val){
      this.upFlag = false;
      if (val.xzgs == 'PDF') {
          this.handopen(val.pxfs)
      }
      if (val.xzgs == 'Excel') {
          this.queryData(val.pxfs)
      }
    }
  },
};
</script>

<style>
.wBenCla:hover{
  color: #0c8b97 !important;
}
.otcCla:hover{
  color: #0c8b97 !important;
}
.hkidrCla:hover{
  color: #0c8b97 !important;
}
.ioqCla:hover{
  color: #0c8b97 !important;
}
.table_stop{
  color: rgb(153, 153, 153) !important;
  cursor: not-allowed;
  opacity: 0.5;
}
.table_stop1{
  color: rgb(153, 153, 153) !important;
  opacity: 0.5;
}
.el-checkbox__inner::after{
  border-color:#777777 !important;
  top: 2px !important;
  left: 5px !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #e7e7e7 !important;
  border-color: #e7e7e7 !important;
}
 .el-checkbox__inner:hover{
  border-color: #e7e7e7 !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #e7e7e7 !important;
}
.el-checkbox__inner{
  width: 17px !important;
  height: 17px !important;
  background: #e7e7e7;
}
#custinforma {
  width: 100%;
  height: 100%;
  padding: 0.9rem;
}

#custinforma .topHeader {
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 1.6rem 1.04rem;
}
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 101;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}
		.pdfview .pdfviewIn1 {
			position: fixed;
      width: 44vw;
      height: 91vh;
      left: calc(50% - 22vw);
      top: 1.5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}

</style>